/* eslint-disable default-case */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import {
  ventaObtenerVentas,
  ventaObtenerVentasExportar,
  ventaArchivarVenta,
} from '../../store/actions';
import {
  Grid,
  Icon,
  Button,
  LinearProgress,
  withStyles,
} from '@material-ui/core';

import { AlertUI, InputUI, ToggleUI, ButtonUI, ModuleTitleUI } from '../common';

import { Validate, Regex, RegexExtra } from '../../other';

import { FilterSidenav, VentasList, ModalArchivar } from './subcomponents';
import moment from 'moment';
import {
  sales_amplitude_events,
  createAmplitudeEventWithDevice,
} from '../amplitude';
import { WrapperLayout } from '../../layouts/WrapperLayout';
let init_date = moment().set('second', 0);

class Ventas_ extends Component {
  state = {
    filter: {
      v_estado_pago: {
        validate: false,
        required: true,
        error: false,
        label: 'Estado de pago',
        id: 'v_estado_pago',
        name: 'v_estado_pago',
        change_param: 'filter',
        value: -2,
        messages: {
          error: '',
        },
      },
      v_metodo_pago: {
        validate: false,
        required: true,
        error: false,
        label: 'Método de pago',
        id: 'v_metodo_pago',
        name: 'v_metodo_pago',
        change_param: 'filter',
        value: 0,
        messages: {
          error: '',
        },
      },
      v_metodo_envio: {
        validate: false,
        required: true,
        error: false,
        label: 'Método de envío',
        id: 'v_metodo_envio',
        name: 'v_metodo_envio',
        change_param: 'filter',
        value: 0,
        messages: {
          error: '',
        },
      },
      v_estado_envio: {
        validate: false,
        required: true,
        error: false,
        label: 'Estado del envío',
        id: 'v_estado_envio',
        name: 'v_estado_envio',
        change_param: 'filter',
        value: -1,
        messages: {
          error: '',
        },
      },
      v_archivada: {
        validate: false,
        required: true,
        error: false,
        label: 'Etiqueta de orden',
        id: 'v_archivada',
        name: 'v_archivada',
        change_param: 'filter',
        value: 0,
        messages: {
          error: '',
        },
      },
      v_mayorista: {
        validate: false,
        required: true,
        error: false,
        label: 'Tipo de venta',
        id: 'v_mayorista',
        name: 'v_mayorista',
        change_param: 'filter',
        value: -1,
        messages: {
          error: '',
        },
      },
      v_factura: {
        validate: false,
        required: true,
        error: false,
        label: 'Facturada',
        id: 'v_factura',
        name: 'v_factura',
        change_param: 'filter',
        value: -1,
        messages: {
          error: '',
        },
      },
      search: {
        auth: false,
        validate: false,
        required: true,
        disabled: false,
        error: false,
        type: 'number',
        label: 'Buscar por número',
        id: 'search',
        name: 'search',
        change_param: 'filter',
        regex: Regex.NUMERO_ENTERO_POSITIVO,
        value: '',
        default_value: '',
        placeholder: '18',
        messages: {
          error: '',
          error_extra: RegexExtra.NUMERO_ENTERO_POSITIVO,
        },
      },
      v_filtrar_fecha: {
        validate: false,
        required: true,
        error: false,
        label: 'Filtrar por fecha',
        id: 'v_filtrar_fecha',
        name: 'v_filtrar_fecha',
        change_param: 'filter',
        value: 0,
        messages: {
          error: '',
        },
      },
      page: 0,
    },

    load_more: {
      loading: false,
      show: false,
    },

    selects: {
      v_estado_pago: [
        {
          value: -2,
          label: 'Todos',
        },
        {
          value: -1,
          label: 'Esperando pago',
        },
        {
          value: 0,
          label: 'Pendientes',
        },
        {
          value: 1,
          label: 'Finalizados',
        },
        {
          value: 2,
          label: 'En proceso',
        },
        {
          value: 3,
          label: 'En mediación',
        },
        {
          value: 4,
          label: 'Rechazado',
        },
        {
          value: 5,
          label: 'Cancelado',
        },
        {
          value: 6,
          label: 'Pago devuelto',
        },
        {
          value: 7,
          label: 'Contracargo',
        },
      ],
      v_metodo_pago: [
        {
          label: 'Todos',
          value: 0,
        },
        {
          label: 'Ualá Bis',
          value: 7,
        },
        {
          label: 'Mercado Pago',
          value: 1,
        },
        {
          label: 'Efectivo',
          value: 2,
        },
        {
          label: 'Acordar',
          value: 3,
        },
        {
          label: 'Todo Pago',
          value: 4,
        },
        {
          label: 'Transferencia',
          value: 5,
        },
        {
          label: 'Mobbex',
          value: 6,
        },
      ],
      v_metodo_envio: [
        {
          value: 0,
          label: 'Todos',
        },
        {
          value: 1,
          label: 'Mercado Envíos',
        },
        {
          value: 2,
          label: 'Retiro en local',
        },
        {
          value: 3,
          label: 'Acordar',
        },
        {
          value: 4,
          label: 'Andreani (Emprepack)',
        },
        {
          value: 5,
          label: 'Envíos personalizados',
        },
        {
          value: 6,
          label: 'OCA',
        },
        {
          value: 7,
          label: 'Email',
        },
        {
          value: 8,
          label: 'Correo Argentino',
        },
        {
          value: 9,
          label: 'E-Pick',
        },
      ],
      v_estado_envio: [
        {
          value: -1,
          label: 'Todos',
        },
        {
          value: 0,
          label: 'Envíos pendientes',
        },
        {
          value: 1,
          label: 'Envíos en preparación',
        },
        {
          value: 2,
          label: 'Enviados / Retirados',
        },
      ],
      v_archivada: [
        {
          label: 'Todas',
          value: -1,
        },
        {
          label: 'No archivadas',
          value: 0,
        },
        {
          label: 'Archivadas',
          value: 1,
        },
      ],
      v_mayorista: [
        {
          value: -1,
          label: 'Todas',
        },
        {
          value: 0,
          label: 'Minoristas',
        },
        {
          value: 1,
          label: 'Mayoristas',
        },
      ],
      v_factura: [
        {
          value: -1,
          label: 'Todas',
        },
        {
          value: 0,
          label: 'Sin facturar',
        },
        {
          value: 1,
          label: 'Facturadas',
        },
      ],
      v_filtrar_fecha: [
        {
          value: 0,
          label: 'No',
        },
        {
          value: 1,
          label: 'Sí',
        },
      ],
    },

    seleccionar_periodo: {
      periodo_desde: {
        validate: false,
        momentobj: init_date.clone().subtract(1, 'days'),
        label: 'Desde',
        name: 'periodo_desde',
        change_param: 'seleccionar_periodo',
      },
      periodo_hasta: {
        validate: false,
        momentobj: init_date.clone(),
        label: 'Hasta',
        name: 'periodo_hasta',
        change_param: 'seleccionar_periodo',
      },
    },

    //carga de datos
    loading: {
      init_ventas: true,
      ventas: true,
      exportar: false,
      error: false,
    },

    //alerta
    alert: {
      open: false,
      type: 'error',
      message: '',
    },

    //modals
    modals: {
      archivar_orden: false,
    },

    //forms
    forms: {
      archivar_orden: false,
    },

    archivar_orden: {
      v_numero: null,
    },

    //sidenav
    filters_sidenav: false,

    //Tipo de sidenav según el botón
    sidenav_type: 'filtrar',

    //Datos de ventas para exportar
    data_exportar: [],
  };

  debounceSearch = null;

  obtenerParametros = (type) => {
    let filter = this.state.filter;

    let body = {
      page: type === 'filtrar' ? filter.page : -1,
    };

    if (filter.v_estado_pago.value !== -2)
      body = { ...body, v_estado_pago: filter.v_estado_pago.value };
    if (filter.v_metodo_pago.value !== 0)
      body = { ...body, v_metodo_pago: filter.v_metodo_pago.value };
    if (filter.v_estado_envio.value !== -1)
      body = { ...body, v_estado_envio: filter.v_estado_envio.value };
    if (filter.v_metodo_envio.value !== 0)
      body = { ...body, v_metodo_envio: filter.v_metodo_envio.value };
    if (filter.v_mayorista.value !== -1)
      body = { ...body, v_mayorista: filter.v_mayorista.value };
    if (filter.v_factura.value !== -1)
      body = { ...body, v_factura: filter.v_factura.value };
    if (filter.v_archivada.value !== -1)
      body = { ...body, v_archivada: filter.v_archivada.value };
    if (filter.search.value !== '')
      body = { ...body, v_numero: filter.search.value };
    if (type === 'exportar') body = { ...body, with_customer: 1 };

    if (filter.v_filtrar_fecha.value === 1) {
      let desde = Validate.moment_local2utc_format(
        this.state.seleccionar_periodo.periodo_desde.momentobj.clone()
      );
      let hasta = Validate.moment_local2utc_format(
        this.state.seleccionar_periodo.periodo_hasta.momentobj
          .clone()
          .set('second', 59)
      );

      body = {
        ...body,
        desde: desde,
        hasta: hasta,
      };
    }

    return body;
  };

  componentDidMount() {
    this.debounceMethod = debounce(this.cargarVentas, 500);

    this.cargarVentas();
  }

  cargarVentas = () => {
    this.setState({
      loading: {
        ...this.state.loading,
        ventas: true,
      },
      load_more: {
        loading: this.state.filter.page > 0 ? true : false,
        show: this.state.filter.page > 0 ? true : false,
      },
    });

    this.props.ventaObtenerVentas(
      this.obtenerParametros('filtrar'),
      (err, resp) => {
        let cantidad_resultados = resp.data.length;

        this.setState({
          loading: {
            ...this.state.loading,
            init_ventas: false,
            ventas: false,
            exportar: false,
            error: this.state.loading.error || err ? true : false,
          },
          load_more: {
            loading: false,
            show: cantidad_resultados === 15,
          },
          filter: {
            ...this.state.filter,
            page: cantidad_resultados === 15 ? this.state.filter.page + 1 : 0,
          },
        });
      }
    );
  };

  exportarVentas = () => {
    this.setState({
      loading: {
        ...this.state.loading,
        exportar: true,
      },
      data_exportar: [],
    });

    this.props.ventaObtenerVentasExportar(
      this.obtenerParametros('exportar'),
      (err, resp) => {
        if (err) {
          this.setState({
            loading: {
              ...this.state.loading,
              init_ventas: false,
              ventas: false,
              exportar: false,
              error: this.state.loading.error || err ? true : false,
            },
            alert: {
              ...this.state.alert,
              open: true,
              message: resp.message,
              type: 'error',
            },
          });
        } else {
          let state = {
            loading: {
              ...this.state.loading,
              init_ventas: false,
              ventas: false,
              exportar: false,
              error: this.state.loading.error || err ? true : false,
            },
            data_exportar: resp.data,
          };

          if (resp.data.length === 0) {
            state = {
              ...state,
              alert: {
                ...this.state.alert,
                open: true,
                message:
                  'No se han encontrado resultados para los filtros seleccionados',
                type: 'error',
              },
            };
          }

          this.setState(state);
        }
      }
    );
  };

  handleChange = (e, blur, aditional) => {
    if (!blur) {
      let value = e.target.value;
      let name = e.target.name;

      this.setState(
        {
          [aditional]: {
            ...this.state[aditional],
            [name]: {
              ...this.state[aditional][name],
              value: value,
            },
            page: 0,
          },
        },
        () => this.debounceMethod()
      );
    }
  };

  handleChangeSelect = (e, aditional) => {
    let value = Validate.trim_int(e.target.value);
    let name = e.target.name;

    this.setState({
      [aditional]: {
        ...this.state[aditional],
        [name]: {
          ...this.state[aditional][name],
          value: value,
        },
      },
    });
  };

  limpiarFiltros = () => {
    this.setState({
      filter: {
        ...this.state.filter,
        v_estado_pago: {
          ...this.state.filter.v_estado_pago,
          value: -2,
        },
        v_metodo_pago: {
          ...this.state.filter.v_metodo_pago,
          value: 0,
        },
        v_metodo_envio: {
          ...this.state.filter.v_metodo_envio,
          value: 0,
        },
        v_estado_envio: {
          ...this.state.filter.v_estado_envio,
          value: -1,
        },
        v_archivada: {
          ...this.state.filter.v_archivada,
          value: 0,
        },
        v_mayorista: {
          ...this.state.filter.v_mayorista,
          value: -1,
        },
        v_factura: {
          ...this.state.filter.v_factura,
          value: -1,
        },
        v_filtrar_fecha: {
          ...this.state.filter.v_filtrar_fecha,
          value: 0,
        },
        search: {
          ...this.state.filter.search,
          value: '',
        },
        page: 0,
      },
      seleccionar_periodo: {
        ...this.state.seleccionar_periodo,
        periodo_desde: {
          ...this.state.seleccionar_periodo.periodo_desde,
          momentobj: init_date.clone().subtract(1, 'days'),
        },
        periodo_hasta: {
          ...this.state.seleccionar_periodo.periodo_hasta,
          momentobj: init_date.clone(),
        },
      },
    });
  };

  //cierra las alertas
  handleCloseAlert = () => {
    this.setState({
      alert: {
        ...this.state.alert,
        open: false,
      },
    });
  };

  //abrir y cerrar drawer
  handleDrawer = (open, type) => {
    this.setState({
      filters_sidenav: open,
      sidenav_type: type,
      data_exportar: this.state.filters_sidenav === false && [],
    });
  };

  modalHandler = (open, id, venta) => {
    switch (id) {
      case 'archivar_orden':
        if (open) {
          this.setState({
            modals: {
              ...this.state.modals,
              [id]: open,
            },
            archivar_orden: {
              v_numero: venta.v_numero,
            },
          });
        } else {
          this.setState({
            modals: {
              ...this.state.modals,
              [id]: open,
            },
          });
        }
        break;
      default:
        this.setState({
          modals: {
            ...this.state.modals,
            [id]: open,
          },
        });
        break;
    }
  };

  handleSubmitArchivarOrden = (e) => {
    e.preventDefault();

    this.setState({
      forms: {
        ...this.state.forms,
        archivar_orden: true,
      },
    });

    let form = this.state.archivar_orden;

    this.props.ventaArchivarVenta(
      {
        v_numero: form.v_numero,
      },
      (err, resp) => {
        if (err) {
          this.setState({
            forms: {
              ...this.state.forms,
              archivar_orden: false,
            },
            alert: {
              open: true,
              message: resp.message,
              type: 'error',
            },
          });
        } else {
          this.setState(
            {
              forms: {
                ...this.state.forms,
                archivar_orden: false,
              },
              alert: {
                open: true,
                message: resp.message,
                type: 'success',
              },
              modals: {
                ...this.state.modals,
                archivar_orden: false,
              },
            },
            () => {
              createAmplitudeEventWithDevice(
                sales_amplitude_events.ventas_archivar_orden.event_name,
                { source: 'listado_ordenes' }
              );
            }
          );
        }
      }
    );
  };

  handleChangeDate = (momentobj, name, aditional) => {
    this.setState({
      [aditional]: {
        ...this.state[aditional],
        [name]: {
          ...this.state[aditional][name],
          momentobj: momentobj,
        },
      },
    });
  };

  handleSubmitFilter = (type, desde, hasta) => {
    if (this.state.filter.v_filtrar_fecha.value === 1) {
      desde = desde.momentobj.clone().set('milliseconds', 0);
      hasta = hasta.momentobj.clone().set('milliseconds', 0);

      let resta_fechas = moment.duration(hasta.diff(desde));

      desde = Validate.moment_local2utc_format(desde.clone());
      hasta = Validate.moment_local2utc_format(hasta.clone());

      if (!Validate.moment_comparar(desde, hasta) && desde !== hasta) {
        this.setState({
          alert: {
            ...this.state.alert,
            open: true,
            type: 'error',
            message: 'La fecha desde no puede ser mayor a la fecha hasta',
          },
        });
      } else if (
        resta_fechas.years() < 1 &&
        resta_fechas.months() < 1 &&
        resta_fechas.days() < 1 &&
        resta_fechas.hours() < 1 &&
        resta_fechas.minutes() >= 0 &&
        resta_fechas.seconds() >= 0
      ) {
        this.setState({
          alert: {
            ...this.state.alert,
            open: true,
            type: 'error',
            message: 'Seleccione al menos una hora de diferencia',
          },
        });
      } else {
        type === 'filtrar'
          ? this.setState(
              {
                filter: {
                  ...this.state.filter,
                  page: 0,
                },
              },
              () => {
                this.cargarVentas();
              }
            )
          : this.exportarVentas();
      }
    } else {
      type === 'filtrar'
        ? this.setState(
            {
              filter: {
                ...this.state.filter,
                page: 0,
              },
            },
            () => {
              this.cargarVentas();
            }
          )
        : this.exportarVentas();
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <WrapperLayout
        loading={this.state.loading.init_ventas}
        error={this.state.loading.error}
      >
        <AlertUI
          open={this.state.alert.open}
          type={this.state.alert.type}
          message={this.state.alert.message}
          handleCloseAlert={this.handleCloseAlert}
        />
        <ModalArchivar
          archivar_orden={this.state.archivar_orden}
          handleSubmit={this.handleSubmitArchivarOrden}
          modalHandler={this.modalHandler}
          modal_state={this.state.modals.archivar_orden}
          form_state={this.state.forms.archivar_orden}
        />
        <FilterSidenav
          filter={this.state.filter}
          selects={this.state.selects}
          filters_sidenav={this.state.filters_sidenav}
          handleDrawer={this.handleDrawer}
          handleChangeSelect={this.handleChangeSelect}
          limpiarFiltros={this.limpiarFiltros}
          periodos={this.state.seleccionar_periodo}
          handleChangeDate={this.handleChangeDate}
          handleSubmitFilter={this.handleSubmitFilter}
          type={this.state.sidenav_type}
          loading={this.state.loading}
          data_exportar={this.state.data_exportar}
          idCountry={this.props.tienda.Country_idCountry}
        />
        <ModuleTitleUI
          title="Ventas"
          subtitles={[
            'Para ver la información completa de una orden en particular, realizar acciones o enviarle notificaciones a un cliente, hace click en el número de orden.',
          ]}
        />
        <div className={classes.filter_box}>
          <Grid container alignItems="center" spacing={24}>
            <Grid item md={5} sm={6} xs={12}>
              <InputUI
                handleChange={this.handleChange}
                input={this.state.filter.search}
                adornment="#"
                end_adornment={<Icon>search</Icon>}
              />
            </Grid>
            <Grid item md={2} xs={6}>
              <Button
                onClick={(e) => this.handleDrawer(true, 'exportar')}
                variant="outlined"
                size="large"
                className={classes.button}
                fullWidth
              >
                <div className={classes.icon_center}>
                  <Icon className={classes.icon_badge}>file_download</Icon>
                  EXPORTAR
                </div>
              </Button>
            </Grid>
            <Grid item md={2} xs={6}>
              <Button
                onClick={(e) => this.handleDrawer(true, 'filtrar')}
                variant="outlined"
                size="large"
                className={classes.button}
                fullWidth
              >
                <div className={classes.icon_center}>
                  <Icon className={classes.icon_badge}>filter_list</Icon>
                  FILTRAR
                </div>
              </Button>
            </Grid>
          </Grid>
        </div>
        <div className={classes.ventas_box}>
          {this.state.filter.page === 0 && this.state.loading.ventas ? (
            <LinearProgress />
          ) : (
            <VentasList modalHandler={this.modalHandler} />
          )}
        </div>
        <ToggleUI show={this.state.load_more.show}>
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid item>
              <ButtonUI
                type="callf"
                label={
                  <div className={classes.icon_center}>
                    VER MÁS{' '}
                    <Icon className={classes.icon_badge_show_more}>
                      keyboard_arrow_down
                    </Icon>
                  </div>
                }
                fullWidth={false}
                onClickFunc={() => this.cargarVentas()}
                isLoading={this.state.load_more.loading}
              />
            </Grid>
          </Grid>
        </ToggleUI>
      </WrapperLayout>
    );
  }
}

const styles = (theme) => ({
  icon_center: {
    display: 'flex',
    alignItems: 'center',
    padding: '3px 0px',
  },
  icon_badge: {
    marginRight: '10px',
  },
  button: {
    marginTop: '2px',
  },
  filter_box: {
    marginTop: '30px',
  },
  ventas_box: {
    margin: '30px 0px',
  },
  icon_badge_show_more: {
    margin: '0',
    padding: '0',
  },
});

const mapStateToProps = (state) => {
  return {
    ventas: state.ventas,
    tienda: state.tienda,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ventaObtenerVentas: (data, callback) =>
      dispatch(ventaObtenerVentas(data, callback)),
    ventaObtenerVentasExportar: (data, callback) =>
      dispatch(ventaObtenerVentasExportar(data, callback)),
    ventaArchivarVenta: (data, callback) =>
      dispatch(ventaArchivarVenta(data, callback)),
  };
};

export const Ventas = withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, mapDispatchToProps)(Ventas_)
);
